import {
  Box,
  Button,
  ComboboxItem,
  Fieldset,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryDelivery } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDmMasterOrg } from "../../../../model/TblDMBranch";
import {
  getCommuneSelectNew,
  getProvinceSelectNew,
} from "../../../../service/getSelectApi";

const CreateDataView = ({ onClose }: CreateDataViewProps) => {
  const entity = {
    id: 0,
    code: null,
    name: null,
    address: null,
    phone: null,
    fax: null,
    email: null,
    note: null,
    location: null,
    road: null,
    province: null,
    country: null,
    channelcode: null,
    isonline: 1, // cờ đang sử dụng, mặc định chi nhánh mới là đang sử dụng
    masterInventoryOrg: null,
    guarantee: null,
    orgId: null,
    townName: null,
    provinceId: null,
    companyCode: "HACOM",
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
    attribute6: null,
    attribute7: null,
    attribute8: null,
    attribute9: null,
    attribute10: null,
    attribute11: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  // theo dõi công ty đang chọn để bật/tắt dấu * của mã Asia
  const [companyCodeSelected, setCompanyCodeSelected] = useState<string | null>(
    "HACOM"
  );

  const [dataNameAddressNew, setDataNameAddressNew] = useState<any>({
    provinceName: "",
    communeName: "",
    addrName: "",
  });
  const [dataProvinceSelectNew, setDataProvinceSelectNew] = useState<
    ComboboxItem[]
  >([]);
  const [dataCommuneSelectNew, setDataCommuneSelectNew] = useState<
    ComboboxItem[]
  >([]);

  const form = useForm<TblDmMasterOrg>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      code: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng nhập mã chi nhánh !";
        }
      },

      name: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng nhập tên chi nhánh !";
        }
      },

      attribute1: (value: string | null | undefined) => {
        if (!value || value.length < 8) {
          return "Số điện thoại không đúng định dạng !";
        }
      },

      channelcode: (value: string | null | undefined, values: any) => {
        // chi nhánh thuộc công ty DVT bắt buộc phải có mã bên ERP Asia
        if (
          values?.companyCode === "DVT" &&
          (!value || value.trim().length === 0)
        ) {
          return "Chi nhánh thuộc công ty DVT phải nhập mã chi nhánh Asia !";
        }
        if (value && value.length > 250) {
          return "Mã chi nhánh Asia không được lớn hơn 250 ký tự !";
        }
      },

      companyCode: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn công ty";
        }
      },

      attribute8: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn tỉnh/TP !";
        }
      },

      attribute9: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn phường/xã !";
        }
      },
    },
  });

  const fetchDataProvinceNew = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceSelectNew(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          }))
      );
    }
  };

  const fetchDataCommuneNew = async (id: string) => {
    const res = await getCommuneSelectNew(id);

    if (res) {
      setDataCommuneSelectNew(
        res
          ?.filter((item) => item.text && item.value)
          ?.map((item) => ({
            value: String(item.value),
            label: String(item.text),
          }))
      );
    }
  };

  const handleCreateTblDebtGroup = async (dataSubmit: TblDmMasterOrg) => {
    open();

    const dataApi = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblDMMasterOrg/create",
      {
        ...dataSubmit,
        address: [
          dataNameAddressNew.addrName,
          dataNameAddressNew.communeName,
          dataNameAddressNew.provinceName,
        ]
          .filter((i) => i && i.length > 0)
          .join(" - "),
        attribute3: [
          dataNameAddressNew.addrName,
          dataNameAddressNew.communeName,
          dataNameAddressNew.provinceName,
        ]
          .filter((i) => i && i.length > 0)
          .join(" - "),
        attribute10:
          dataNameAddressNew.addrName.length > 0
            ? dataNameAddressNew.addrName
            : null,
      }
    );
    if (dataApi?.success) {
      setTimeout(() => {
        onClose((prev: any) => !prev);
        modals.closeAll();
      }, 1000);

      NotificationExtension.Success("Thêm chi nhánh thành công !");
    }
    close();
  };

  useEffect(() => {
    Promise.all([fetchDataProvinceNew()]);
  }, []);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: TblDmMasterOrg) => {
          handleCreateTblDebtGroup(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Mã chi nhánh"
              placeholder="Nhập mã chi nhánh"
              key={form.key("code")}
              {...form.getInputProps("code")}
              withAsterisk
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Mã chi nhánh Asia"
              placeholder="Nhập mã chi nhánh bên ERP Asia"
              key={form.key("channelcode")}
              {...form.getInputProps("channelcode")}
              withAsterisk={companyCodeSelected === "DVT"}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Tên chi nhánh"
              placeholder="Nhập tên chi nhánh"
              key={form.key("name")}
              {...form.getInputProps("name")}
              withAsterisk
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Select
              label="Công ty"
              placeholder="Chọn công ty"
              data={[
                { label: "HACOM", value: "HACOM" },
                { label: "DVT", value: "DVT" },
              ]}
              key={form.key("companyCode")}
              {...form.getInputProps("companyCode")}
              onChange={(value) => {
                form.setFieldValue("companyCode", value ?? "");
                setCompanyCodeSelected(value);
                form.validateField("channelcode");
              }}
              withAsterisk
            />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              key={form.key("phone")}
              label="SĐT chi nhánh"
              placeholder="Nhập SĐT chi nhánh"
              {...form.getInputProps("phone")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="SĐT bảo hành"
              placeholder="Nhập SĐT bảo hành"
              type="number"
              key={form.key("attribute1")}
              {...form.getInputProps("attribute1")}
              withAsterisk
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              key={form.key("attribute11")}
              label="SĐT chi nhánh dùng cho GV"
              placeholder="Nhập SĐT chi nhánh dùng cho GV"
              type="number"
              {...form.getInputProps("attribute11")}
            />
          </Grid.Col>
        </Grid>
        {/* <Fieldset legend="Địa chỉ chi nhánh (Trước khi sáp nhập tỉnh)">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Tỉnh/TP"
                placeholder="Chọn tỉnh/thành phố"
                data={dataProvinceSelect}
                key={form.key("attribute4")}
                withAsterisk
                {...form.getInputProps("attribute4")}
                onChange={(e) => {
                  if (e) {
                    fetchDataDistrict(String(e));
                    form.setFieldValue("attribute4", e);
                    form.setFieldValue("attribute5", null);
                    form.setFieldValue("attribute6", null);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      provinceName: getValueById(
                        String(e),
                        dataProvinceSelect,
                        "label"
                      ),
                      districtName: "",
                      communeName: "",
                    }));
                  } else {
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      provinceName: "",
                      districtName: "",
                      communeName: "",
                    }));
                    form.setFieldValue("attribute4", null);
                    form.setFieldValue("attribute5", null);
                    form.setFieldValue("attribute6", null);
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Quận/huyện"
                placeholder="Chọn quận/huyện"
                withAsterisk
                data={dataDistrictSelect}
                key={form.key("attribute5")}
                {...form.getInputProps("attribute5")}
                disabled={dataNameAddress.provinceName.length === 0}
                onChange={(e) => {
                  if (e) {
                    fetchDataCommune(String(e));
                    form.setFieldValue("attribute5", e);
                    form.setFieldValue("attribute6", null);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      districtName: getValueById(
                        String(e),
                        dataDistrictSelect,
                        "label"
                      ),
                      communeName: "",
                    }));
                  } else {
                    form.setFieldValue("attribute5", null);
                    form.setFieldValue("attribute6", null);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      districtName: "",
                      communeName: "",
                    }));
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Phường/Xã"
                placeholder="Chọn phường/xã"
                withAsterisk
                data={dataCommuneSelect}
                key={form.key("attribute6")}
                {...form.getInputProps("attribute6")}
                disabled={dataNameAddress.districtName.length === 0}
                onChange={(e) => {
                  if (e) {
                    form.setFieldValue("attribute6", e);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      communeName: getValueById(
                        String(e),
                        dataCommuneSelect,
                        "label"
                      ),
                    }));
                  } else {
                    form.setFieldValue("attribute6", e);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      communeName: "",
                    }));
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <TextInput
                label="Địa chỉ cụ thể"
                placeholder="Nhập địa chỉ cụ thể"
                key={form.key("attribute7")}
                {...form.getInputProps("attribute7")}
                onChange={(e) =>
                  setDataNameAddress((prev: any) => ({
                    ...prev,
                    addrName: e.currentTarget.value,
                  }))
                }
              />
            </Grid.Col>
          </Grid>
        </Fieldset> */}
        {/* <Fieldset legend="Địa chỉ chi nhánh (Sau khi sáp nhập tỉnh)"> */}
        <Fieldset legend="Địa chỉ chi nhánh">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Tỉnh/TP"
                placeholder="Chọn tỉnh/thành phố"
                withAsterisk
                data={dataProvinceSelectNew}
                key={form.key("attribute8")}
                {...form.getInputProps("attribute8")}
                onChange={(e) => {
                  if (e) {
                    fetchDataCommuneNew(String(e));
                    form.setFieldValue("attribute8", e);
                    form.setFieldValue("attribute9", null);
                    setDataNameAddressNew((prev: any) => ({
                      ...prev,
                      provinceName: getValueById(
                        String(e),
                        dataProvinceSelectNew,
                        "label"
                      ),
                      communeName: "",
                    }));
                  } else {
                    setDataNameAddressNew((prev: any) => ({
                      ...prev,
                      provinceName: "",
                      communeName: "",
                    }));
                    form.setFieldValue("attribute8", null);
                    form.setFieldValue("attribute9", null);
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Phường/Xã"
                placeholder="Chọn phường/xã"
                withAsterisk
                data={dataCommuneSelectNew}
                key={form.key("attribute9")}
                {...form.getInputProps("attribute9")}
                disabled={dataNameAddressNew?.provinceName.length === 0}
                onChange={(e) => {
                  if (e) {
                    form.setFieldValue("attribute9", e);
                    setDataNameAddressNew((prev: any) => ({
                      ...prev,
                      communeName: getValueById(
                        String(e),
                        dataCommuneSelectNew,
                        "label"
                      ),
                    }));
                  } else {
                    setDataNameAddressNew((prev: any) => ({
                      ...prev,
                      communeName: "",
                    }));
                    form.setFieldValue("attribute9", null);
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
                label="Địa chỉ cụ thể"
                placeholder="Nhập địa chỉ cụ thể"
                key={form.key("attribute10")}
                {...form.getInputProps("attribute10")}
                onChange={(e) =>
                  setDataNameAddressNew((prev: any) => ({
                    ...prev,
                    addrName: e.currentTarget.value,
                  }))
                }
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
                label="Số thứ tự hiển thị"
                placeholder="Nhập số thứ tự hiển thị"
                key={form.key("attribute2")}
                {...form.getInputProps("attribute2")}
              />
            </Grid.Col>
          </Grid>
        </Fieldset>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default CreateDataView;

type CreateDataViewProps = {
  onClose: any;
};
